import { api } from "../component/constent";
 export const dataProcess = (month, year) =>
  api.post("/procedure/execute", {reportId: 35, params: [month, year],});
export const currentMonth = (month, year) =>
  api.get("/reports/currentMonth");

